module.exports = "<ion-app>\n  <ngx-ui-loader></ngx-ui-loader>\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>"